import {SET_CUSTOMER} from '../actions/types';

const customer = (state= null, action) => {
  switch (action.type) {
    case SET_CUSTOMER:
      return action.payload;
    default:
      return state;
  }
};

export default customer;